export default function MenuButton({ updateMenuState }) {

  return (
    <button 
      id="menu-button"
      onClick={updateMenuState}
    >
    </button>
  )
}